import { useEffect, useRef, useState } from 'react';

import { log } from '@/services';

/**
 * @param target - The target date in ISO string format
 * @returns time left in milliseconds
 */
export const useCountdown = (target?: string) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!target) return;
    const targetTime = new Date(target).getTime();
    if (isNaN(targetTime)) {
      log(new Error('Invalid app login magic link expiresAt value'));
      return;
    }

    const stopTicker = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };

    const calculateTimeLeft = () => {
      const now = new Date().getTime();

      if (targetTime <= now) {
        setTimeLeft(0);
        stopTicker();
      } else {
        setTimeLeft(Math.floor(targetTime - now));
      }
    };

    calculateTimeLeft();
    intervalRef.current = setInterval(calculateTimeLeft, 1000);

    return () => {
      stopTicker();
    };
  }, [target]);

  return timeLeft;
};
